import axios from "axios";
import { LocalStorageKey } from "../constants/localStorageKeys";



axios.interceptors.request.use(
      (config) =>
      {
            const staticConfig = localStorage.getItem(LocalStorageKey.STATIC_CONFIG);
            if (staticConfig)
            {
                  const parsedConfig = JSON.parse(staticConfig);
                  const authMethod = parsedConfig.REACT_APP_AUTHENTICATION_METHOD;

                  if (authMethod === "OAUTH2")
                  {
                        const accessToken = localStorage.getItem("token");
                        const tokenType = localStorage.getItem("token_type") || "Bearer";

                        if (accessToken)
                        {
                              // @ts-ignore
                              config.headers = {
                                    ...config.headers,
                                    Authorization: `${tokenType} ${accessToken}`,
                              };
                        }
                  }

                  if (authMethod === "COOKIES")
                  {
                        config.withCredentials = true;
                  }
            }
            return config;
      },
      (error) => Promise.reject(error)
);

let isRefreshing = false;
let subscribers: any[] = [];

function onRefreshed(token: string)
{
      subscribers.forEach((callback) => callback(token));
      subscribers = [];
}

function addSubscriber(callback: any)
{
      subscribers.push(callback);
}

axios.interceptors.response.use(
      (response) => response,
      async (error) =>
      {
            const originalRequest = error.config;
            const staticConfig = localStorage.getItem(LocalStorageKey.STATIC_CONFIG);
            const parsedConfig = staticConfig ? JSON.parse(staticConfig) : {};

            const authMethod = parsedConfig.REACT_APP_AUTHENTICATION_METHOD;

            if (error.response?.status === 401)
            {
                  console.log(authMethod, 'authMethod');
                  if (!originalRequest._retry)
                  {
                        if (authMethod === 'OAUTH2')
                        {
                              originalRequest._retry = true;

                              if (isRefreshing)
                              {
                                    // Đang refresh → thêm request vào hàng đợi
                                    return new Promise((resolve) =>
                                    {
                                          addSubscriber((newToken: string) =>
                                          {
                                                originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
                                                resolve(axios(originalRequest));
                                          });
                                    });
                              }

                              isRefreshing = true;

                              const savedKey = localStorage.getItem("key");

                              const params = new URLSearchParams();
                              params.append("grant_type", "client_credentials");

                              try
                              {
                                    // Tạo instance không interceptor!
                                    const axiosNoInterceptor = axios.create();
                                    const response = await axiosNoInterceptor.post(
                                          parsedConfig.REACT_APP_KEY_URL_OAUTH2,
                                          params,
                                          {
                                                headers: {
                                                      "Content-Type": "application/x-www-form-urlencoded",
                                                      Authorization: `${parsedConfig.REACT_APP_AUTHENTICATION_TYPE} ${savedKey}`,
                                                },
                                          }
                                    );

                                    const newToken = response.data?.access_token;
                                    localStorage.setItem("token", newToken);

                                    // Gọi lại các request bị queue
                                    onRefreshed(newToken);

                                    // Gửi lại request gốc
                                    originalRequest.headers["Authorization"] = `${parsedConfig.REACT_APP_AUTHENTICATION_TYPE} ${newToken}`;

                                    return axios(originalRequest);
                              } catch (err)
                              {

                                    localStorage.removeItem("token");
                                    localStorage.removeItem("token_type");

                                    if (authMethod === "COOKIES")
                                    {
                                          const redirect =
                                                parsedConfig.REACT_APP_ENDPOINT_ACCOUNT +
                                                "?redirect_url=" +
                                                btoa(window.location.origin + window.location.pathname);



                                          window.location.href = redirect
                                    } else
                                    {
                                          window.location.href =
                                                parsedConfig.REACT_APP_ENDPOINT_ACCOUNT
                                    }

                                    return Promise.reject(err);
                              } finally
                              {
                                    isRefreshing = false;
                              }
                        } else
                        {
                              localStorage.removeItem("token");
                              localStorage.removeItem("token_type");


                              const redirect =
                                    parsedConfig.REACT_APP_ENDPOINT_ACCOUNT +
                                    "?redirect_url=" +
                                    btoa(window.location.origin + window.location.pathname);



                              window.location.href = redirect



                        }
                  } else
                  {
                        if (authMethod !== 'OAUTH2')
                        {
                              localStorage.removeItem("token");
                              localStorage.removeItem("token_type");


                              const redirect =
                                    parsedConfig.REACT_APP_ENDPOINT_ACCOUNT +
                                    "?redirect_url=" +
                                    btoa(window.location.origin + window.location.pathname);



                              window.location.href = redirect
                        }

                  }


                  return Promise.reject(error);
            }

            if (error?.status === 400)
            {
                  return error
            }
      }
);

export default axios;
